import {
  Box,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  Tooltip,
} from '@material-ui/core';
import { CancelIcon, DotIcon, NotificationIcon } from 'app/assets/images/icons';
import { handleDownloadFile } from 'app/utils/handle-download-file';
import { checkTranslated } from 'app/utils/helpers';
import { _t } from 'app/utils/i18n';
import { getFromLocalStorage } from 'app/utils/localStorage';
import { savePrevSearchState } from 'app/utils/search-state';
import NoNotification from 'notifications/components/NoNotification';
import NotificationUserItem from 'notifications/components/NotificationUserItem';
import {
  getNotificationsCount,
  loadAllNotificationsData,
  makeNotificationSeen,
  notificationRead,
} from 'notifications/Requests';
import {
  renderPageDetailRout,
  renderSubMedulePageDetailRout,
} from 'notifications/utils/helpers';
import { useSnackbar } from 'notistack';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';
import NotificationDotsMenu from '../NotificationDotsMenu';

import styles from './Notifications.module.scss';
import { getPreSignedUrl } from 'archive/Requests';

interface Props {
  data?: any;
}
const useStyles = makeStyles((theme) => ({
  paper: {
    border: '1px solid var(--borderColor)',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    padding: ' 0',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    top: '39px !important',
    width: '367px',
    color: 'var(--mainColor)',
    height: 'auto',
  },
}));
const tabs = [
  { label: _t('basic:all'), index: 0 },
  { label: _t('notifications:unread'), index: 1 },
];
const user_id = getFromLocalStorage('user_id');
const access_token = getFromLocalStorage('access_token');
const socket = new WebSocket(
  `${
    process.env.REACT_APP_API_BASE_URL?.includes('https')
      ? process.env.REACT_APP_API_BASE_URL?.replace('https', 'wss')
      : process.env.REACT_APP_API_BASE_URL?.replace('http', 'wss')
  }notifications/ws/${user_id}?access_token=${access_token}`
);
const Notifications: FunctionComponent<Props> = ({ data }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationsData, setNotificationsData] = useState([]);
  const [isActive, setIsActive] = useState(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setIsAllRead] = useState(false);
  const snackBar = useSnackbar();
  const enqueueSnackbar = snackBar?.enqueueSnackbar;
  const closeSnackbar = snackBar?.closeSnackbar;

  const [notificationsCount, setNotificationsCount] = useState<number>(0);
  const [notificationsAlertData, setNotificationsAlertData] = useState<any[]>(
    []
  );
  useEffect(() => {
    socket.onopen = () => {
      console.log('Connected');
    };
    socket.onerror = () => {
      console.log('Error');
    };

    socket.onmessage = (e) => {
      setNotificationsCount(JSON.parse(e?.data)?.count);
      setNotificationsAlertData([JSON.parse(e?.data)]);
    };
  }, []);

  const history = useHistory();
  const buttonIsDisable =
    history?.location?.pathname === '/notifications/notifications';
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setNotificationsCount(0);
    setAnchorEl(event.currentTarget);
    refetch();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // GET ALL NOTIFICATIONS DATA
  const { refetch } = useQuery(
    [
      'loadAllNotificationsData',
      { un_read: isActive === 1 ? true : '', limit: 15 },
    ],
    loadAllNotificationsData,
    {
      enabled: open,
      // refetchInterval: open ? 3000 : undefined,
      onSuccess: (res) => {
        setNotificationsData(res.records);
        setIsAllRead(false);
      },
    }
  );

  //GET NOTIFICATIONS COUNT
  useQuery(
    ['getNotificationsCount', { un_seen: true }],
    getNotificationsCount,
    {
      onSuccess: (res) => {
        setNotificationsCount(res.count);
      },
    }
  );

  // GET NEW DATA FOR  ALERT
  // const { data: notificationsAlertData } = useQuery(
  //   ['getAlertNotificationsInApp', { last_seconds: 2 }],
  //
  // );

  // GET MAKE READ FOR ONE NOTIFICATION OR ALL
  const { mutateAsync: ReadTheNotification } = useMutation(notificationRead, {
    onSuccess: () => setNotificationsCount(0),
  });

  // GET MAKE SEEN FOR NOTIFICATIONS
  const { mutateAsync: MakeNotificationSeen } =
    useMutation(makeNotificationSeen);
  const handleActive = (Active: boolean, index: number) => {
    Active && setIsActive(index);
  };

  const newNotificationsData = data ? data : notificationsData;

  // GET NOW NOTIFICATIONS
  const notificationIsNow = newNotificationsData?.filter((ele: any) =>
    ele?.is_now ? ele : null
  );
  // GET EARLIER NOTIFICATIONS
  const notificationIsEarlier = newNotificationsData?.filter((ele: any) =>
    !ele?.is_now ? ele : null
  );
  // NO DETAILS PAGES FOR TRASGED , DELETED OR UNNECESSARY
  const notificationNotClick = ['DELETE', 'TRASH', 'UNNECESSARY'];
  const subModuleNotClick = ['CATEGORIES', 'TAGS', 'PERMISSIONS'];
  const { mutate: getPreSignedUrlMutate } = useMutation(getPreSignedUrl, {
    onSuccess: ({ payload }) => {
      handleDownloadFile(payload);
    },
  });
  const downloadReport = (url: any) => {
    getPreSignedUrlMutate({ url: url });
  };

  const { pathname } = useLocation();
  const currentId =
    pathname?.split('/')?.[1] === 'trends'
      ? +pathname?.split('/')?.[4]
      : +pathname?.split('/')?.[3];
  useEffect(() => {
    refetch();
  }, [isActive]);
  const queryClient = useQueryClient();
  const handleNotationClick = (ele: any) => {
    if (ele?.module == 'INFLUENCERS') {
      queryClient.removeQueries('influencerDetails');
    }
    if (ele.action === 'DOWNLOAD' && ele.item) {
      downloadReport(ele?.item);
      ReadTheNotification({ ids: [ele?.id] });
      handleClose?.();
      return;
    }
    handleClose?.();
    if (
      notificationNotClick.includes(ele.item_status) ||
      subModuleNotClick.includes(ele?.sub_module) ||
      ele.item_id == 0
    ) {
      ReadTheNotification({ ids: [ele?.id] });
    } else {
      ReadTheNotification({ ids: [ele?.id] });
      history.push(
        savePrevSearchState(
          ele?.sub_module == ''
            ? renderPageDetailRout(
                ele?.module.toLowerCase(),
                ele?.item_id,
                ele?.item
              )
            : renderSubMedulePageDetailRout(
                ele?.sub_module,
                ele?.item_id,
                ele?.module,
                ele?.sub_sub_module
              )
        )
      );
      if (currentId === ele?.item_id) {
        window.location.reload();
      }
    }
  };

  //IN APP NOTIFICATIONS ALERT
  useEffect(() => {
    if (notificationsAlertData?.length > 0) {
      notificationsAlertData?.map((ele) =>
        enqueueSnackbar(
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <NotificationUserItem
              user_id={ele?.user_id}
              userName={ele?.user_name}
              text={checkTranslated(ele?.message, ele?.message_ar)}
              image={ele.user_image}
              time={ele.created_on}
              usageWithAlart
            />
            <IconButton style={{ padding: 5 }} onClick={() => closeSnackbar()}>
              <CancelIcon style={{ width: 10, height: 10 }} />
            </IconButton>
          </div>
        )
      );
    }
  }, [notificationsAlertData]);

  return (
    <div className={styles.Notifications}>
      <Box
        style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}
        onClick={open || (!open && buttonIsDisable) ? handleClose : handleClick}
      >
        <Tooltip title={`${_t('basic:notifications')}`}>
          <IconButton
            onClick={(e) => {
              handleClick(e);
              MakeNotificationSeen({});
            }}
            size="small"
            style={{ marginLeft: 2, position: 'relative' }}
            disabled={buttonIsDisable}
          >
            <NotificationIcon
              className={buttonIsDisable ? styles.isDisable : ''}
              // onClick={handleClick}
              data-testid="notification-icon-holder"
            />
            {notificationsCount > 0 && (
              <div
                className={styles.notificationsCount}
                data-testid="notifi-count-holder"
              >
                <div className={styles.counter}>{notificationsCount}</div>
              </div>
            )}
          </IconButton>
        </Tooltip>
      </Box>
      <div className="popper" data-testid="popper-holder">
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            className: `${classes.paper} ${styles.menuArrow}`,
            elevation: 0,
            style: {
              overflow: 'visible',
              marginTop: 1.5,
              top: '50px',
            },
          }}
          transformOrigin={{ horizontal: 'center', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        >
          <MenuItem onClick={(e) => e.stopPropagation()}>
            <div
              className="notifications"
              style={{
                fontSize: '17px',
                padding: 0,
                borderBlockEnd: '1px solid var(--borderColor)',
              }}
            >
              <div>{_t('basic:notifications')}</div>

              <NotificationDotsMenu
                ReadTheNotification={ReadTheNotification}
                // setIsAllRead={setIsAllRead}
                handleMenuClose={handleClose}
              />
            </div>
          </MenuItem>
          <Tabs>
            {tabs?.map((tab, index) => (
              <Tab
                key={index}
                label={tab?.label}
                onClick={(e) => {
                  handleActive(tab?.index === index, index);
                  e.stopPropagation();
                }}
                style={{
                  color: `${
                    isActive == index ? 'var(--secondaryColor)' : 'inherit'
                  }`,
                }}
              />
            ))}
          </Tabs>
          {newNotificationsData?.length ? (
            <div>
              {notificationIsNow?.length ? (
                <MenuItem onClick={(e) => e.stopPropagation()}>
                  <div
                    style={{
                      paddingBlock: '5px',
                      borderTop: '1px solid var(--borderColor)',
                      width: '100%',
                      borderBlockEnd: 'none',
                    }}
                    className="notifications"
                  >
                    {_t('notifications:now')}
                  </div>
                </MenuItem>
              ) : null}
              {notificationIsNow?.map((ele: any) => (
                <MenuItem
                  key={ele?.id}
                  style={{
                    background: `${!ele?.is_read ? 'var(--bodyColor)' : ''}`,
                  }}
                  onClick={() => {
                    handleNotationClick(ele);
                  }}
                >
                  <div className="notifications">
                    <NotificationUserItem
                      user_id={ele?.user_id}
                      userName={ele?.user_name}
                      text={checkTranslated(ele?.message, ele?.message_ar)}
                      image={ele.user_image}
                      time={ele.created_on}
                    />
                    {!ele?.is_read && (
                      <DotIcon style={{ width: 10, height: 10 }} />
                    )}
                  </div>
                </MenuItem>
              ))}
              {notificationIsEarlier?.length ? (
                <MenuItem onClick={(e) => e.stopPropagation()}>
                  <div
                    style={{
                      paddingBlock: '5px',
                      borderTop: '1px solid var(--borderColor)',
                      width: '100%',
                      borderBlockEnd: 'none',
                    }}
                    className="notifications"
                  >
                    {_t('notifications:earlier')}
                  </div>
                </MenuItem>
              ) : null}
              {notificationIsEarlier?.map((ele: any) => (
                <MenuItem
                  key={ele?.id}
                  style={{
                    background: `${!ele?.is_read ? 'var(--bodyColor)' : ''}`,
                  }}
                  onClick={() => {
                    handleNotationClick(ele);
                  }}
                >
                  <div className="notifications">
                    <NotificationUserItem
                      user_id={ele?.user_id}
                      userName={ele?.user_name}
                      text={checkTranslated(ele?.message, ele?.message_ar)}
                      image={ele.user_image}
                      time={ele.created_on}
                    />
                    {!ele?.is_read && (
                      <DotIcon style={{ width: 10, height: 10 }} />
                    )}
                  </div>
                </MenuItem>
              ))}
            </div>
          ) : (
            <NoNotification smallSize />
          )}
        </Menu>
      </div>
    </div>
  );
};

export default Notifications;
